import React, {useEffect, useState} from "react";
import Button from "olive-react-myoneui/lib/Button";
import SampleImage2 from "../../../assets/images/sample2.jpg";
import { liveOnlineIcon,calendarIcon } from '../../../../src/constants/icons';
import IconDesc from "../my-course/IconDesc";
import moment from 'moment';

function EventScheduleList({selectedTimeZone, session, setTotalLecturesCount, setTotalCoursesCount, slno, className}) {
  const [name, setName] = useState(session.ea_name);
  const [image, setImage] = useState('');
  const [venue, setVenue] = useState('Online');
  const [lecturesCount, setLecturesCount] = useState(0);
  const [coursesCount, setCoursesCount] = useState(0);
  const [eventTimeFull, setEventTimeFull] = useState('');
  
  const GetMonthName = (monthNumber, full=false) =>{
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if(full){
      return monthsFull[monthNumber - 1];
    } else {
      return months[monthNumber - 1];
    }
  }

  useEffect(() => {
    if(session.ea_session_delivery_type == 'offline'){
      let venueTemp = session.ea_venue_name + '-' + session.ea_session_venue_room;
      setVenue(venueTemp);
    }
    if(session.ea_activity_type == 'Course')
    {
      setVenue('Online');
      setName(session.cb_title);
      setImage(session.cb_image);
      setLecturesCount(session.cb_lecture_count);
      setTotalLecturesCount((prev) => prev + session.cb_lecture_count);
      setTotalCoursesCount((prev) => prev + 1);
    }
    else if(session.ea_activity_type == 'Bundle'){
      setVenue('Online');
      setName(session.c_title);
      setImage(session.c_image);
      setCoursesCount(session.bundle_length);
      console.log('bundle', session.bundle_length);
      setTotalCoursesCount((prev) => prev + session.bundle_length);
    }

    //time set
    if(session.ea_activity_type == 'session'){

      let selected_timezone = selectedTimeZone?.name_without_offset;
  
      let default_start_datetime = moment(session.ea_session_start_date + ' ' + session.ea_session_start_time, "YYYY-MM-DD h:mm:ss A").tz('UTC', true);
      
      let default_end_datetime = moment(session.ea_session_end_date + ' ' + session.ea_session_end_time, "YYYY-MM-DD h:mm:ss A").tz('UTC', true);
  
      let start_date_tz = default_start_datetime.format("DD-MM-YYYY");
      let start_time_tz = default_start_datetime.format("h:mm A");
      let end_date_tz = default_end_datetime.format("DD-MM-YYYY");
      let end_time_tz = default_end_datetime.format("h:mm A");
  
      if (typeof selected_timezone !== 'undefined' && selected_timezone != '') {
        var tz_start_datetime = moment(default_start_datetime).tz(selected_timezone);
        var tz_end_datetime = moment(default_end_datetime).tz(selected_timezone);
        start_date_tz = tz_start_datetime.format("DD-MM-YYYY");
        start_time_tz = tz_start_datetime.format("h:mm A");
        end_date_tz = tz_end_datetime.format("DD-MM-YYYY");
        end_time_tz = tz_end_datetime.format("h:mm A");                 
        
      }
  
      var date_diff                    = (Date.parse(end_date_tz) - Date.parse(start_date_tz))/86400000;
                
      var weekday                     = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
      var startDate                   = start_date_tz.split('-');
      var startMonth                  = GetMonthName(Number(startDate[1]).toString());
      let startMonthFull              = GetMonthName(Number(startDate[1]).toString(), true);
      var startDay                    = startDate[0];
      var newDate                     = new Date(startDate[1]+'/'+startDate[0]+'/'+startDate[2]);
      var startDayName                = weekday[newDate.getDay()];
      var startMonthNumber            = (newDate.getMonth())+1;
      let startYear                   = startDate[2];
  
      let startDateOnly               = `${startDayName}, ${startDay} ${startMonthFull} ${startYear}`; 
  
      var endDate                      = end_date_tz.split('-');
      var endMonth                     = GetMonthName(Number(endDate[1]).toString());
      var endDay                       = endDate[0];
      var endYear                      = endDate[2];
  
      var now   = moment(default_end_datetime);
      var then  = moment(default_start_datetime);
    
      var duration    = moment.duration(now.diff(then));
      var dayDiff     = duration.days();
      var hourDiff    = duration.hours();
      var minutesDiff = duration.minutes();
      var diff = '';
      if (dayDiff > 0) {                
          diff += dayDiff + ' D ';
      }
      if (hourDiff > 0) {                
        diff += hourDiff + ' Hr ';
      }
      if (minutesDiff > 0) {                
        diff += minutesDiff + ' Min';
      }
  
      // setEventTimeDiff(diff);
  
      // if (session.course.bce_schedule_type == 'basic' && selected_timezone != '') {
        // if(tz_start_datetime.format("L") === tz_end_datetime.format("L")) {
        //   setEventTimeFull(start_time_tz+' - '+end_time_tz+' ('+diff+')');
        // } else {
          setEventTimeFull(startDay+' '+startMonth+' '+startYear+' '+start_time_tz+' - '+endDay+' '+endMonth+' '+endYear+' '+end_time_tz);
        // }
      // }
    //end time set
    }

  },[session, selectedTimeZone])
  return (
    <>
      <div className={`${className || ''} event-schedule-wrapper mb-3`}>
        <div className="event-schedule-content">
          <div className="event-title d-flex align-items-center gap-2">
            <div className="event-img-wrapper">
              {
                session.ea_activity_type == 'session' ? (
                <IconDesc
                  icon={calendarIcon}
                />) : 
                (
                  <img src={image} alt="Event Image" className="img-fluid" />
                )
              }
            </div>
          </div>
          <div className="event-lecture-wrap">
            <h1 className="title">{name}</h1>  
            {session.ea_activity_type == 'Course' &&
              <div className="lecture-count">
                <p>No: of Lectures</p>
                <h1>{lecturesCount}</h1>
              </div>
            }
            {session.ea_activity_type == 'Bundle' &&
              <div className="lecture-count">
                <p>No: of Courses</p>
                <h1>{coursesCount}</h1>
              </div>
            }
            {
              session.ea_activity_type == 'session' &&
              <div className="lecture-count">
                <p>Event Date</p>
                <h1>{eventTimeFull}</h1>
              </div>
            }
            
            <div className="lecture-venue">
              <p>Venue</p>
              <h1>{venue}</h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EventScheduleList;
